"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const cast_1 = require("../../utilites/cast");
const ImageInfo_1 = require("./ImageInfo");
class VideoInfo extends ImageInfo_1.ImageInfo {
    constructor() {
        super(...arguments);
        this.duration = 0;
    }
    static from(object) {
        return cast_1.castToType(object, VideoInfo);
    }
}
exports.VideoInfo = VideoInfo;
VideoInfo.propFactory = Object.assign({}, ImageInfo_1.ImageInfo.propFactory);
